import type { BuildingSocietyLoanConfig } from '../BuildingSocietyLoanConfig';

export const loan: BuildingSocietyLoanConfig = {
    overview: {
        highlights: {
            showInstallment: false,
            showBalance: false,
            showRepayments: true,
            showLoanAmount: true,
        },
        list: {
            showIbanAndBic: true,
            showLoanAmount: false,
            showNextInstallmentDate: false,
            showDebitInterestRate: false,
            showAdditionalInfo: false,
            showStartDate: true,
        },
    },
    settingsDetails: {
        showSlashedBBAN: false,
    },
};
